<template lang="html">

    <span>
      <el-select v-model="channelId" :multiple="multiple" :placeholder="placeholder"
          clearable
          filterable
          remote
          reserve-keyword
          style="width:400px"
          :remote-method="remoteMethod"
          @change="onChange">
        <el-option
         v-for="(item,index) in channels"
         :key="item.id"
         :label="item.businessName+','+item.contacts+','+item.phone"
         :value="index">
       </el-option>
      </el-select>
    </span>

</template>

<script>
import BasicModel from '@/framework/basic/BasicModel'
export default {
  name:'plush-business-select',
  data: function(){
    return {
      channels: [],
      channelId: [],
    };
  },
  props: {
    multiple: {
      type: Boolean,
      default: function()  {
        return false
      }
    },
    placeholder: {
      type: String,
      default: function(){
        return '请选择'
      }
    }
  },
  methods: {
    onChange: function(index){
      this.$emit('change',this.channels[index])
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.findChannels(query)
        }, 200);
      } else {
        this.options = [];
      }
    },
    settingDefaultChannelInfo(channelInfo){
      this.channels = [channelInfo]
    },
    clear: function(){
      this.channelId = []
    },
    setChannelIds: function(channelId) {
      this.channelId = channelId
    },
    findChannels: function(query) {

        let params = {
          keyword: query,
          pageNum:1,
          pageSize: 10
        }
        let _this = this
        let listener = {
            success: function(dataInfo) {
                _this.channels = dataInfo.data
            }
        }
        BasicModel.get(_this,'lcwpbusiness/findBusiness.action',params, listener)
    }
  }
}
</script>

<style lang="css">
</style>
